export default __webpack_public_path__ + "static/media/aboutUs2Large.5c4247d1.webp";